import { useMemo } from 'react';
import cn from 'classnames';
import { compact } from 'lodash-es';
import { Button, Separator, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { routes } from "../../../constants";
import { useStore } from "../../../contexts";
import { useIsMobileForHomePage } from "../../../hooks/useIsMobileForHomePage";
import { useSwitchBusiness } from "../../../hooks/useSwitchBusiness";
import { selectors } from "../../../store/state-selectors";
import { BusinessSwitcherForSpecificUsers } from "../BusinessSwitcher/BusinessSwitcher";
import { HelpMenu } from "../HelpMenu";
import { InAppNotificationsButton } from "../InAppNotificationsButton";
import UserMenu from "../UserMenu/UserMenu";
import { QuickActionsMenu } from "./QuickActionsMenu/QuickActionsMenu";
import { SidebarMenu } from "./SidebarMenu/SidebarMenu";
import styles from "./TopBar.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const AnchorAdmin = _ref => {
  let {
    companyName
  } = _ref;
  return /*#__PURE__*/_jsxs(Typography, {
    variant: "paragraph2",
    breakWords: true,
    children: ["You are now logged as an Anchor Admin to", ' ', /*#__PURE__*/_jsx(Typography, {
      as: "span",
      weight: "bold",
      children: companyName
    })]
  });
};
export const getTopBarTID = () => getTestIds();
export function TopBar() {
  const {
    TopBarTID
  } = useMemo(() => getTopBarTID(), []);
  const isMobileDevice = useIsMobileForHomePage();
  const userInfo = useStore(state => state.userInfo);
  const userId = useStore(selectors.user.id);
  const isVendor = useStore(selectors.user.isVendor);
  const businessName = useStore(selectors.user.businessName);
  const isAccountant = useStore(selectors.user.isAccountant);
  const isAnchorAdmin = useStore(selectors.user.isAnchorAdmin);
  const {
    switchBusiness,
    getPrevBusinessId
  } = useSwitchBusiness();
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": TopBarTID.Root(),
    className: cn(styles.root, {
      [styles.accountant]: isAccountant,
      [styles.anchorAdmin]: isAnchorAdmin,
      [styles.mobile]: isMobileDevice
    }),
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.start,
      children: [isMobileDevice && /*#__PURE__*/_jsx(SidebarMenu, {}), isAccountant && /*#__PURE__*/_jsxs("div", {
        className: styles.accountantSection,
        children: [/*#__PURE__*/_jsxs(Typography, {
          variant: "paragraph2",
          children: ["You are now logged in to", ' ', /*#__PURE__*/_jsx(Typography, {
            as: "span",
            variant: "paragraph2",
            weight: "normal",
            children: businessName
          })]
        }), /*#__PURE__*/_jsx(Button, {
          className: styles.backBtn,
          size: "small",
          skin: "primaryOutline",
          testId: TopBarTID.BackToMyBusiness(),
          onClick: () => switchBusiness(getPrevBusinessId(), {
            newRoute: routes.agreementsDashboard
          }),
          children: "Back to my business"
        })]
      }), isAnchorAdmin && businessName && /*#__PURE__*/_jsx(AnchorAdmin, {
        companyName: businessName
      }), !isMobileDevice && /*#__PURE__*/_jsx(BusinessSwitcherForSpecificUsers, {})]
    }), /*#__PURE__*/_jsxs("div", {
      className: cn(styles.end, {
        [styles.mobile]: isMobileDevice
      }),
      "data-testid": TopBarTID.EndContainer(isVendor ? 'vendor' : 'client'),
      children: [compact([{
        id: 'marketing-content',
        value: null
      }, {
        id: 'help',
        value: userId && /*#__PURE__*/_jsx(HelpMenu, {})
      }, isVendor && {
        id: 'in-app-notifications',
        value: /*#__PURE__*/_jsx(InAppNotificationsButton, {})
      }, userInfo && userId && {
        id: 'user',
        value: /*#__PURE__*/_jsx(UserMenu, {
          userInfo: userInfo
        })
      }]).map(_ref2 => {
        let {
          id,
          value
        } = _ref2;
        return /*#__PURE__*/_jsx("div", {
          "data-testid": TopBarTID.EndItem(id),
          className: styles.endItem,
          children: value
        }, id);
      }), isMobileDevice && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Separator, {
          vertical: true,
          spacing: "none",
          height: 32
        }), /*#__PURE__*/_jsx(QuickActionsMenu, {})]
      })]
    })]
  });
}